<template>
    <div class="wrap">
        <div class="top">
            <div class="title"><img src="@/assets/images/logo.png" alt="" /></div>
        </div>
        <div class="text">
            <h4>《弹壳特攻队》适龄提示</h4>
            <p></p>
            1、本游戏是一款Roguelike类战术射击手机游戏，适用于年满8周岁及以上的用户，建议未成年人在家长监护下使用游戏产品。
            <p></p>
            2、本游戏以虚拟的城市为背景。危险的生物正在攻击整个城市，玩家为了拯救世界，成为身负重任的战士，挺身而出对抗强大的敌人。玩家通过努力，最终战胜了敌人，收复被敌人攻占的城市。游戏画面色彩鲜明，玩法简单，无社交功能。
            <p></p>
            3、本游戏中有用户实名认证系统，认证为未成年人的用户将接受以下管理：
            游戏中部分道具需要付费。未满8周岁的用户不能付费；8周岁以上未满16周岁的未成年人用户，单次充值金额不得超过50元人民币，每月充值累计金额不得超过200元人民币；16周岁以上未满18岁的未成年人用户，单次充值金额不得超过100元人民币，每月充值累计金额不得超过400元人民币。
            未成年人用户仅可在周五、周六、周日和法定节假日每日20时至21时使用本游戏。
            <p></p>
            4、游戏以射击玩法为主，画面精美，能够带给玩家愉悦的游戏氛围。游戏中玩家通过技能的选择和躲避攻击，有策略地获得战斗的胜利，游戏可以充分发挥玩家的主动性，调动玩家的积极情绪。通过游戏，还能够锻炼玩家的思考力。
        </div>
        <div class="btn">
            <span @click="handleClose">确&nbsp;&nbsp;&nbsp;&nbsp;定</span>
        </div>
    </div>
</template>

<script>
export default {
    props: ['isShow'],
    data() {
        return {
            isChannel: true,
            objData: {}
        }
    },
    created() {
        if (this.isShow) {
            this.isChannel = false
        }
    },
    mounted() {
        this.objData = JSON.parse(localStorage.getItem('data'))
        // 禁止双指放大
        document.documentElement.addEventListener(
            'touchstart',
            function (event) {
                if (event.touches.length > 1) {
                    event.preventDefault()
                }
            },
            false
        )
        var lastTouchEnd = 0
        document.documentElement.addEventListener(
            'touchend',
            function (event) {
                var now = Date.now()
                if (now - lastTouchEnd <= 300) {
                    event.preventDefault()
                }
                lastTouchEnd = now
            },
            false
        )
        document.addEventListener('gesturestart', function (event) {
            event.preventDefault()
        })
    },
    methods: {
        handleClose() {
            this.$emit('handleCloseAgreement', true)
        }
    }
}
</script>


<style scoped lang="less">
.wrap {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: #ffffff;
    width: 90%;
    max-width:600px ;
    min-height: 200px;
    padding: 4rem 2rem;
    border-radius: 1rem;
    .top {
        display: flex;
        justify-content: space-between;
        line-height: 32px;
        .title {
            font-weight: 800;
            font-size: 1.4rem;
            /* display: flex; */
            flex-direction: row;
            align-items: center;
            width: 100%;
        }
        img {
            width: 34%;
            margin-right: 0.625rem;
        }
    }
    .text {
        background: #f4f7f8;
        color: #91969d;
        font-size: 0.6rem;
        text-align: left;
        padding: 2rem;
        line-height: 1.6;
        margin: 2.4rem 0 4rem;
        max-height: 60vh;
        // overflow: scroll;
        overflow-x: hidden;
        h4 {
            font-size: 1.1rem;
            text-align: center;
        }
        h3 {
            margin-top: 1rem;
        }
        p {
            margin-top: 1rem;
            text-indent: 1.2rem;
        }
    }
    .btn {
        display: block;
        margin-top: 1.875rem;
        span {
            background: #d5574b;
            border-radius: 3rem;
            padding: 1.6rem 4rem;
            color: #ffffff;
            cursor: pointer;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/children.vue